import { useMemo } from 'react';

import { useParams } from '@tanstack/react-router';

import type { IBlock } from '@dcentralexpedientedigital/fe-shared/types/config.interface';
import { useDemographicsData } from '@dcentralexpedientedigital/fe-ui/hooks/use-user-demographic-data';
import { applyTargetAudienceFilter } from '@dcentralexpedientedigital/fe-ui/utils/apply-target-audience-filter';
import { resolveParams } from '@dcentralexpedientedigital/fe-ui/utils/resolve-params';

import { isComponentBlock } from '../utils/is-component-block';

import { useActiveRouteData } from './use-active-route-data';

export function useProcessedBlocks(blocks: IBlock[]) {
    const params = useParams({
        strict: false,
    }) as Record<string, string>;
    const demographicParams = useDemographicsData();

    const routeData = useActiveRouteData();

    return useMemo(() => {
        return applyTargetAudienceFilter(
            blocks.map((block) => {
                if (!isComponentBlock(block)) {
                    if ('components' in block && Array.isArray(block.components)) {
                        // if the block has a layout structure
                        const processedComponents = applyTargetAudienceFilter(
                            block.components.map((component) => ({
                                targetAudience: {},
                                ...component,
                                properties: resolveParams(component.properties, params),
                            })),
                            demographicParams,
                            routeData,
                        );
                        return {
                            targetAudience: {},
                            ...block,
                            components: processedComponents,
                        };
                    } else {
                        console.warn('Unexpected block structure:', block);
                        return {
                            ...block,
                            targetAudience: {},
                        };
                    }
                }

                return {
                    targetAudience: {},
                    ...block,
                    properties: resolveParams(block.properties, params),
                };
            }),
            demographicParams,
        );
    }, [params, demographicParams, blocks]);
}
